












import {
  Vue,
  Component,
  Prop,
  Inject,
  InjectReactive
} from "vue-property-decorator";
import widgets from "../package/widgets";
import wgetMgr from "../package/widgets/wgetMgr";

@Component({
  name: "MagicChildrenBlock",
  components: { ...widgets }
})
export default class MagicChildrenBlock extends Vue {
  @Prop({
    type: String,
    required: true
  })
  private blockId!: string;

  @Inject()
  private model!: any;

  /**
   * 当前属于第几行数据
   */
  @InjectReactive("row")
  private row!: number;

  @InjectReactive("loop")
  private loop!: string;

  @InjectReactive("tableName")
  private tableName!: string;

  @InjectReactive("htmlOptions")
  private params!: { options: App.WebForm.Config; model: any; isHtml: boolean };

  /**
   * 子表组件中组件的真正id
   */
  get childrenBlockId() {
    return this.blockId + ":" + this.loop;
  }

  get parent(): App.WebForm.ChildrenTableWidget {
    const parent = this.params.options.widgets.find(
      (d) => d.property.propertyName === this.tableName
    );
    return (parent ? parent : { id: "-1" }) as App.WebForm.ChildrenTableWidget;
  }

  get widget(): App.WebForm.Widget {
    if (this.parent.id === "-1") return { id: "-1" } as App.WebForm.Widget;
    const rowList = this.parent.widgetList[this.row];
    const widget = rowList.find((d) => d.id === this.childrenBlockId);
    return (widget ? widget : { id: "-1" }) as App.WebForm.Widget;
  }

  get style() {
    const style: any = {};
    if (this.widget?.readonly) {
      style.width = "auto";
      style.minWidth = "0px";
      return {
        width: "auto",
        minWidth: "0",
        minHeight: "auto",
        verticalAlign: "auto",
        margin: 0,
        padding: 0
      };
    } else if (this.widget?.isCustomBlockWidth) {
      style.width = (this.widget.blockWidth || 0) + "px";
      style.minWidth = "20px";
    }
    return style;
  }

  mounted() {
    if (this.widget && this.widget?.id !== "-1") {
      wgetMgr.setWidgetById(this.widget.id, this.$refs[this.widget.id]);
    }
  }
}
